export default __webpack_public_path__ + "static/media/js.ffcf56dc.svg";